module.exports = __webpack_public_path__ + "img/warehouse-management.cb651385.jpg";